import type { Header } from "@tanstack/react-table";

export const renderGridTemplateColumns = <T>(
  headers: Header<T, unknown>[],
): React.CSSProperties => ({
  gridTemplateColumns: headers
    .map((header: Header<T, unknown>) => `${header.getSize()}px`)
    .join(" "),
});
